<template>
    <div class="merchantList">
		<div style="margin-bottom: 20px;">
		    <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
		</div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<div style="margin-bottom:20px">
				<span>总奖励额：{{mainItem.reward_money_all}}元    月结奖励额：{{mainItem.month_reward_money_all}}元   年结奖励额：{{mainItem.year_reward_money_all}}元</span>
			</div>
            <el-table
                :data="rewardList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 日期 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="reward_time"
                    label="日期"
                    min-width="100"
                ></el-table-column>
                <!-- 总交易量(元) -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="transtion_money"
                    label="总交易量(元)"
                    min-width="120"
                ></el-table-column>
				<!-- 月结-分润奖励额(元) -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="month_rebate_money"
				    label="月结-分润奖励额(元)"
				    min-width="150"
				></el-table-column>
				<!-- 月结-流量卡奖励额(元) -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="month_flow_money"
				    label="月结-流量卡奖励额(元)"
				    min-width="150"
				>
				</el-table-column>
				<!-- 月结-提现税点奖励额(元) -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="month_withfee_money"
				    label="月结-提现税点奖励额(元)"
				    min-width="200"
				>
				</el-table-column>
                <!-- 年结-分润奖励额(元) -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="year_rebate_money"
                    label="年结-分润奖励额(元)"
                    min-width="150"
                >
                </el-table-column>
				<!-- 年结-流量卡奖励额(元) -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="year_flow_money"
				    label="年结-流量卡奖励额(元)"
				    min-width="150"
				></el-table-column>
				<!-- 年结-提现税点奖励额(元) -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="year_withfee_money"
				    label="年结-提现税点奖励额(元)"
				    min-width="200"
				>
				</el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "saleRewardDetail",
    data() {
        return {
            searchForm: {
				start_time: '',
				end_time: '',
                person_id: this.$route.query.person_id,
				limit:10,
				page: 1
            },
            rangeDate: '',
            rewardList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
			mainItem:{}
        }
    },
    mounted() {
        this.getData(this.searchForm)
    },
    methods: {
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("sale/selSaleRewardDayList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.rewardList = res.data.list;
				this.mainItem = data
                //渲染结束后取消加载
                this.loading = false;
				
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        }
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>